module.exports = __webpack_public_path__ + "static/media/man-shirt-black-portrait-3565711.6e1c5316.png";